import { jwtDecode } from 'jwt-decode';

import type { AuthenticatedUser } from '@puffin/app-frame-api';

export const getUserFromAccessToken = (accessToken: string): AuthenticatedUser | undefined => {
  try {
    const claims = jwtDecode<Record<string, unknown>>(accessToken);
    const name = typeof claims.name === 'string' ? claims.name : undefined;
    const usernameClaim = claims.preferred_username ?? claims.upn ?? claims.email;
    const username = typeof usernameClaim === 'string' ? usernameClaim : undefined;
    const itdId = typeof claims['itd-id'] === 'string' ? claims['itd-id'] : undefined;
    const roles = Array.isArray(claims.roles) && claims.roles.every((role): role is string => typeof role === 'string') ? claims.roles : [];
    const applicationIdClaim = claims.azp ?? claims.appid;
    const applicationId = typeof applicationIdClaim === 'string' && applicationIdClaim ? applicationIdClaim : undefined;
    const displayName = name ?? username ?? (applicationId ? `App ${applicationId}` : undefined);
    if (!displayName) {
      return undefined;
    }
    return { name: displayName, username, itdId, roles };
  } catch {
    return undefined;
  }
};
